// import utils
import i18n from 'config/i18n';
import { isDate } from 'date-fns';
import * as yup from 'yup';
import { getLocale } from 'utils/date';

function editDutyCodeSchema() {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup
    .object({
      displayDutyCode: yup
        .string()
        .required(t('validationFieldRequired', { name: t('dutyCode') })),
      colorCode: yup.mixed(),
      validFrom: yup
        .date()
        .transform((value) => (isDate(value) ? value : undefined))
        .typeError(t('validationFieldRequired', { name: t('validFrom') }))
        .required(t('validationFieldRequired', { name: t('validFrom') })),
      validTo: yup
        .date()
        .transform((value) => (isDate(value) ? value : undefined))
        .typeError(t('validationFieldRequired', { name: t('validTo') }))
        .min(
          yup.ref('validFrom'),
          t('validationNotBefore', {
            first: t('validFrom'),
            last: t('validTo')
          })
        )
        .required(t('validationFieldRequired', { name: t('validTo') }))
    })
    .required();
}

export default editDutyCodeSchema;
